module.exports = __webpack_public_path__ + "assets/img/jump.27ed1434.svg";